import React, { Dispatch, SetStateAction, useRef } from "react";
import classes from "../SharePopUp/SharePopUp.module.scss";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { Button } from "../Button/Button";
import useOutsideClick from "../../hooks/useOutsideClick";
import { copyToClipboard } from "../../helpers/copyToClipBoard";

interface Props {
 title: string;
 emailSubject: string;
 emailShare: string;
 jobLink: string;
 linkCopy: string;
 doneButton: string;
 setShowPopUp: Dispatch<SetStateAction<boolean>>;
  className?: string;
 [x: string]: any;
}

export const SharePopUp: React.FC<Props> = ({
    title,
    emailSubject,
    emailShare,
    jobLink,
    linkCopy,
    setShowPopUp,
    doneButton,
    style,
    props,
    className,
  }) => {
  const ref = useRef<HTMLDivElement>(null);
  const copyTextRef = useRef<HTMLDivElement>(null);

  const handleOutsideClick = () => {
    setShowPopUp(false);
  };

  const handleCopy = () => {
    copyToClipboard(window.location.href);
    if (copyTextRef?.current) {
      let range = document.createRange();
      range.selectNodeContents(copyTextRef.current);
      let sel = window.getSelection();
      sel?.removeAllRanges();
      sel?.addRange(range);
    }
  };

  useOutsideClick(ref, handleOutsideClick);

  return (
    <div
      {...props}
      style={style}
      ref={ref}
      className={`
        ${classes.sharePopup}
        ${className}
      `}
    >
      <div className={classes.sharePopupContentWrapper}>
        <div className={classes.sharePopupContent}>
          <div className={classes.sharePopupTitle}>
            { title }
          </div>
          <a
            href={`mailto:?subject=${emailSubject}&body=${window.location.href}`}
            className={classes.sharePopupJobAction}
          >
            { emailShare }
          </a>
          <div className={classes.sharePopupJobLink}>
            { jobLink }
          </div>
          <div className={classes.sharePopupJobShare}>
            <div
              ref={copyTextRef}
              className={classes.sharePopupUrl}
            >
              { window.location.href }
            </div> {' '}
            <button
              className={classes.sharePopupCopy}
              onClick={handleCopy}
            >
                { linkCopy }
              </button>
          </div>
          <div
            onClick={() => setShowPopUp(false)}
            className={classes.sharePopupCloseButton}
          >
            <CloseIcon />
          </div>
        </div>
        <div className={classes.sharePopupConfirm}>
          <Button
            onClick={() => setShowPopUp(false)}
            variant="transparent"
          >
            { doneButton }
          </Button>
        </div>
      </div>
    </div>
  );
};